import {
    NEXT_STAGE_UPLVLRNW,
    PREVIOUS_STAGE,
    TOTAL_STAGES,
    SUBMIT_FINAL,
    NEXT_BUTTON_UPDATE,
    SAVE_AND_EXIT_UPDATE,
  NEXT_BUTTON_UPDATE_UPLVLRNW,
  SET_IS_COC_VALIDATION_REGION
} from '../config/constants';
import { ContentMap } from '../config/contentMap';
  
  const INITIAL_STATE = {
    currentStage: 0,
    isValidated: true,
    isSaveAndExit: false,
    isCOCValidateRequired: false,
  };
  
  export default (state = INITIAL_STATE, { type, payload }) => {
    switch (type) {
      case NEXT_STAGE_UPLVLRNW: {
        if(state.currentStage !== ContentMap.forms.length) {
          return { ...state, currentStage: state.currentStage+1,stepList: state.stepList+1 };
        } else {
          return { ...state };
        }
      }
      case PREVIOUS_STAGE: {
        if(state.currentStage > 0) {
          return { ...state, currentStage: state.currentStage-1,stepList: state.stepList-1 };
        } else {
          return { ...state };
        }
      }
      case SUBMIT_FINAL: {
        
        return { ...state };
      }
      case NEXT_BUTTON_UPDATE_UPLVLRNW: {
        return { ...state, isValidated: !payload };
      }
      case SAVE_AND_EXIT_UPDATE: {
        return { ...state, isSaveAndExit: payload };
      }
      case SET_IS_COC_VALIDATION_REGION: {
        return { ...state, isCOCValidateRequired: payload };
      }
      default:
        return state;
    }
  };
  